import { API } from '../../api'
import { chatServiceUrl } from '../../utils/constants'

/** A past conversation as returned by the v2 list-sessions endpoint. */
export interface ChatSessionSummary {
  session_id: string
  /** Display title — the conversation's first user message. */
  conversation_title: string
  /** Owning agent, e.g. "Funding Agent". */
  agent_type: string
  /** ISO-8601, or null when unknown. */
  created_at: string | null
  /** ISO-8601, or null when unknown. */
  updated_at: string | null
}

export interface ChatSessionsRequestBody {
  user_id: string
  /** Page size, 1–100. Defaults to 20 server-side. */
  limit?: number
  /** Sessions to skip — offset pagination (`offset = page * limit`). */
  offset?: number
  /**
   * Case-insensitive substring filter on the conversation title. Omit (or send
   * `null`/`""`) to list everything. `total`/`has_more` reflect the filtered
   * set, so offset paging works the same over search results. Title-only — does
   * not search message bodies.
   */
  search?: string
}

export interface ChatSessionsResponse {
  /** This page of sessions, newest-first by created time. */
  sessions: ChatSessionSummary[]
  /** Total sessions for this partner + user across all pages. */
  total: number
  limit: number
  offset: number
  has_more: boolean
}

/**
 * List a user's past chat sessions for a partner, newest-first. Drives the chat
 * history sidebar. Pagination is offset-based (distinct from `/chat/history`,
 * which is cursor-based) — request page `n` with `offset = n * limit`.
 */
export const getChatSessionsAPI = (
  partnerId: string,
  body: ChatSessionsRequestBody
) =>
  API.post<ChatSessionsResponse>(
    `${chatServiceUrl}/v2/partners/${partnerId}/chat/sessions`,
    body
  )
